import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useUpdatePaymentTerms(
  briefId?: string,
  handleCallback?: () => void
) {
  const {
    mutate: updatePaymentTerms,
    isLoading: isUpdating,
    isSuccess: isUpdated,
    variables,
  } = useMutation({
    mutationFn: (data: { briefInfluencerId: string; paymentTerms: string }) =>
      BriefService.updatePaymentTerms(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      handleCallback?.();
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
    },
  });

  return {
    updatePaymentTerms,
    isUpdating,
    isUpdated,
    variables,
  };
}
